module.exports = __webpack_public_path__ + "img/logo.379e4752.png";